//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            circuitCircles: [{
                id: 0,
                x: 220,
                y: 470,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180, 270]),
            }, {
                id: 1,
                x: 290,
                y: 650,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0, 270])
            }, {
                id: 2,
                x: 490,
                y: 480,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90, 180])
            }, {
                id: 3,
                x: 630,
                y: 290,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90, 180])
            }, {
                id: 4,
                x: 850,
                y: 290,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180, 270])
            }, {
                id: 5,
                x: 800,
                y: 520,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0, 270])
            }, {
                id: 6,
                x: 1020,
                y: 180,
                angle: 270,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [90, 180])
            }, {
                id: 7,
                x: 150,
                y: 650,
                angle: 0,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(7, [0, 270])
            }, {
                id: 8,
                x: 350,
                y: 480,
                angle: 0,
                active: () => (this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(8, [90, 180])) ||
                    (this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]) &&
                    this.circuitHasAngle(10, [90])) &&
                    this.circuitHasAngle(8, [0, 270])
            }, {
                id: 9,
                x: 280,
                y: 210,
                angle: 0,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]) &&
                    this.circuitHasAngle(9, [90, 180]) &&
                    this.circuitHasAngle(10, [90])
            }, {
                id: 10,
                x: 420,
                y: 210,
                angle: 0,
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]) &&
                    this.circuitHasAngle(10, [0, 90])
            }],
            circuits: [{
                active: () => this.circuitHasAngle(0, [270]),
                lines: [{
                    x: 220,
                    y: 420,
                    length: 70,
                    angle: 180
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]),
                lines: [{
                    x: 220,
                    y: 520,
                    length: 30,
                    angle: 0
                }, {
                    x: 220,
                    y: 550,
                    length: 70,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 220,
                    y: 550,
                    length: 70,
                    angle: 90,
                    hideCircle: true
                }, {
                    x: 290,
                    y: 550,
                    length: 50,
                    angle: 0,
                    hideCircle: true
                }, {
                    x: 150,
                    y: 550,
                    length: 50,
                    angle: 0,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]),
                lines: [{
                    x: 340,
                    y: 650,
                    length: 80,
                    angle: 270
                }, {
                    x: 420,
                    y: 650,
                    length: 80,
                    angle: 180
                }, {
                    x: 420,
                    y: 570,
                    length: 70,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 420,
                    y: 570,
                    length: 70,
                    angle: 90,
                    hideCircle: true
                }, {
                    x: 490,
                    y: 570,
                    length: 40,
                    angle: 180,
                    hideCircle: true
                }, {
                    x: 350,
                    y: 570,
                    length: 40,
                    angle: 180,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]),
                lines: [{
                    x: 540,
                    y: 480,
                    length: 150,
                    angle: 270
                }, {
                    x: 690,
                    y: 480,
                    length: 80,
                    angle: 180
                }, {
                    x: 690,
                    y: 400,
                    length: 60,
                    angle: 90,
                    hideCircle: true
                }, {
                    x: 630,
                    y: 400,
                    length: 60,
                    angle: 180,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]),
                lines: [{
                    x: 680,
                    y: 290,
                    length: 120,
                    angle: 270,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]),
                lines: [{
                    x: 850,
                    y: 340,
                    length: 70,
                    angle: 0
                }, {
                    x: 850,
                    y: 410,
                    length: 50,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 900,
                    y: 410,
                    length: 60,
                    angle: 0
                }, {
                    x: 850,
                    y: 410,
                    length: 50,
                    angle: 90,
                    hideCircle: true
                }, {
                    x: 800,
                    y: 410,
                    length: 60,
                    angle: 0,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]),
                lines: [{
                    x: 850,
                    y: 520,
                    length: 100,
                    angle: 270
                }, {
                    x: 950,
                    y: 520,
                    length: 200,
                    angle: 180
                }, {
                    x: 950,
                    y: 320,
                    length: 70,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 1020,
                    y: 320,
                    length: 90,
                    angle: 180,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [90]),
                lines: [{
                    x: 1070,
                    y: 180,
                    length: 90,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 1160,
                    y: 180,
                    length: 308,
                    angle: 0,
                    hideCircle: true
                }, {
                    x: 1160,
                    y: 488,
                    length: 170,
                    angle: 90,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(7, [270]),
                lines: [{
                    x: 100,
                    y: 650,
                    length: 40,
                    angle: 90
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]) &&
                    this.circuitHasAngle(10, [90]),
                lines: [{
                    x: 350,
                    y: 430,
                    length: 100,
                    angle: 180
                }, {
                    x: 350,
                    y: 330,
                    length: 70,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 350,
                    y: 330,
                    length: 70,
                    angle: 90,
                    hideCircle: true
                }, {
                    x: 280,
                    y: 330,
                    length: 70,
                    angle: 180,
                    hideCircle: true
                }, {
                    x: 420,
                    y: 330,
                    length: 70,
                    angle: 180,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]),
                lines: [{
                    x: 470,
                    y: 210,
                    length: 380,
                    angle: 270
                }, {
                    x: 850,
                    y: 210,
                    length: 100,
                    angle: 270,
                    hideCircle: true
                }, {
                    x: 950,
                    y: 210,
                    length: 70,
                    angle: 0
                }, {
                    x: 850,
                    y: 210,
                    length: 30,
                    angle: 180,
                    hideCircle: true
                }, {
                    x: 850,
                    y: 180,
                    length: 120,
                    angle: 270,
                    hideCircle: true
                }]
            }, {
                active: () => this.circuitHasAngle(0, [180]) &&
                    this.circuitHasAngle(1, [0]) &&
                    this.circuitHasAngle(2, [90]) &&
                    this.circuitHasAngle(3, [90]) &&
                    this.circuitHasAngle(4, [180]) &&
                    this.circuitHasAngle(5, [0]) &&
                    this.circuitHasAngle(6, [180]) &&
                    this.circuitHasAngle(9, [180]) &&
                    this.circuitHasAngle(10, [90]),
                lines: [{
                    x: 230,
                    y: 210,
                    length: 100,
                    angle: 90
                }, {
                    x: 130,
                    y: 210,
                    length: 70,
                    angle: 180,
                    hideCircle: true
                }, {
                    x: 130,
                    y: 140,
                    length: 700,
                    angle: 270
                }]
            }, {
                active: () => true,
                lines: [{
                    x: 55,
                    y: 360,
                    length: 70,
                    angle: 270
                }, {
                    x: 55,
                    y: 445,
                    length: 70,
                    angle: 270
                }, {
                    x: 55,
                    y: 530,
                    length: 70,
                    angle: 270
                }, {
                    x: 77,
                    y: 415,
                    length: 48,
                    angle: 270
                }, {
                    x: 77,
                    y: 495,
                    length: 48,
                    angle: 270
                }, {
                    x: 77,
                    y: 575,
                    length: 48,
                    angle: 270
                }, {
                    x: 125,
                    y: 360,
                    length: 215,
                    angle: 0,
                    hideCircle: true
                }, {
                    x: 125,
                    y: 470,
                    length: 45,
                    angle: 270,
                    hideCircle: true
                }]
            }]
        };
    },

    computed: {
        solved () {
            return this.circuitHasAngle(0, [180]) &&
                this.circuitHasAngle(1, [0]) &&
                this.circuitHasAngle(2, [90]) &&
                this.circuitHasAngle(3, [90]) &&
                this.circuitHasAngle(4, [180]) &&
                this.circuitHasAngle(5, [0]) &&
                this.circuitHasAngle(6, [90]);
        },
        result () {
            return {
                stars: this.solved ? 5 : 0,
                correct: this.solved ? 1 : 0,
                wrong: this.solved ? 0 : 1
            };
        }
    },

    methods: {
        rotate (circuit) {
            circuit.angle = (circuit.angle === 270) ? 0 : circuit.angle + 90;
        },
        circuitHasAngle (id, angles = []) {
            return this.circuitCircles.some(circuit => circuit.id === id && angles.includes(circuit.angle));
        }
    }
};
